import { createI18n } from 'vue-i18n'
import { translations, fallbackLocale } from './translations/messages'

function customRule(choice) {
	if (choice === 0) {
		return 0;
	}
	const teen = (choice % 100) > 10 && (choice % 100) < 20;
	if (teen) {
		return 3;
	}
	const lastDigit = choice % 10;
	if (lastDigit === 1) {
		return 1;
	}
	if (lastDigit >= 2 && lastDigit <= 4) {
		return 2;
	}
	return 3;
}

const i18n = createI18n({
	locale: fallbackLocale,
	fallbackLocale: fallbackLocale,
	legacy: false,
	pluralRules: {
		ru: customRule,
	},
	messages: translations,
})

export default i18n
